"use client"

import Image from "next/image"
import { MotionDiv } from "@/components/motion"
import EmailCapture from "./EmailCapture"

export default function Newsletter() {
  return (
    <section className="relative py-0">
      {/* Grunge background - full width, no overlay */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url('/images/Grunge background.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 1,
        }}
      />

      {/* Dark purple overlay on top of grunge for text readability */}
      <div className="absolute inset-0 z-0 bg-gradient-to-r from-[#1A0A2E] via-[#2D1155] to-transparent" />

      {/* Content wrapper */}
      <div className="relative z-10 max-w-7xl mx-auto min-h-[500px] flex items-center">
        <div className="grid lg:grid-cols-2 gap-0 items-stretch w-full">
          {/* Left - Copy + Form */}
          <div className="px-8 lg:px-16 py-16 flex flex-col justify-center">
            <MotionDiv
              variants={{ hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0 } }}
              className="flex flex-col justify-center"
            >
              <span className="text-sm font-normal text-white/60 uppercase tracking-widest mb-3 font-antonio">
                Join the Movement
              </span>
              <h2 className="text-4xl sm:text-5xl lg:text-6xl text-white leading-tight font-antonio font-bold mb-6 uppercase">
                JOIN THE
                <br />
                <span className="text-[#7B45C1]">SQUAD</span>
              </h2>
              <p className="text-white/80 text-base lg:text-lg font-normal leading-relaxed mb-10 max-w-md">
                Be part of the change. Stay updated on our programs, school visits, and community events. Together, we can end bullying.
              </p>
              <EmailCapture variant="inline" />
              <p className="text-xs text-white/40 mt-4 font-normal font-antonio">
                We respect your privacy. Unsubscribe at any time.
              </p>
            </MotionDiv>
          </div>
        </div>
      </div>

      {/* Group photo - absolutely positioned right side, no bottom padding */}
      <div className="absolute right-0 bottom-0 w-[48%] h-full z-5 flex items-end">
        <div className="relative w-full h-full">
          <Image
            src="/images/Group Selfie.png"
            alt="Bully Talk community"
            fill
            className="object-contain object-right-bottom !absolute"
            sizes="48vw"
          />
        </div>
      </div>
    </section>
  )
}